import fetchApi from '../util/fetchApi';
import checkErrors from './checkErrors';

export const UweHubApi = {
    async isConfigured() {
        return (await checkErrors(await fetchApi.api.get('uwe-hub/is-configured'))).data;
    },

    async getModuleEmbedUrl({ moduleRoute }) {
        return (await checkErrors(await fetchApi.api.get('uwe-hub/module-embed-url', { query: { moduleRoute } }))).data;
    },
};

export default UweHubApi;
